import { API_URL, API_KEY, FILTER_SERVICE } from '../configs/global';

export const FETCH_SERVICES = 'FETCH_SERVICES';

export const getId = (obj, index) => {
  if (!!obj && !!obj.request && !!obj.request.length && !!obj.request[index]) {
    return obj.request[index].groupId
      ? obj.request[index].groupId
      : obj.request[index].stopId;
  }
  return '';
};

export const getName = (obj, index) => {
  if (!!obj && !!obj.request && !!obj.request.length && !!obj.request[index]) {
    return obj.request[index].ticketName;
  }
  return '';
};

export const fetchServices = (
  fromId,
  toId,
  type,
  showValidationMsgs,
  history,
  cb
) => {
  let url = '';
  let fromUnix = Math.round((new Date()).getTime() / 1000) - (6 * 3600);
  let toUnix = fromUnix + (36 * 3600);
  if (type !== 'service')
    if (toId)
      url = `${API_URL}/public-departures-between-stops-v1/${fromId}/${toId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
    else
      url = `${API_URL}/public-departures-by-stop-v1/${fromId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;
  else  
  url = `${API_URL}/public-origin-departures-by-route-v1/${fromId}/${fromUnix}/${toUnix}?api_key=${API_KEY}${FILTER_SERVICE ? '&only_service_classes=' + FILTER_SERVICE : ''}`;


  return (dispatch) => {
    fetch(url)
      .then((response) => response.json())
      .then((response) => {
        if (response.routes)
          response.stops = response.routes;
        if (showValidationMsgs) {
          if (response && !response.stops[0].chronological_departures.length) {
            showValidationMsgs(true);
          } else {
            showValidationMsgs(false);
            if (type === 'between')
              history.push(`/view/between/${fromId}/${toId}`);
            else if (type === 'reference')
              history.push(`/view/reference/${fromId}`);
            else if (type === 'stop') history.push(`/view/stop/${fromId}`);
            else if (type === 'service')
              history.push(`/view/service/${fromId}`);

            let recentSearches = localStorage.recentSearches;
            let arr = [];

            if (recentSearches && recentSearches.length) {
              recentSearches = JSON.parse(recentSearches);
              const duplicateSearch = recentSearches.filter(
                (search) =>
                  getId(search, 0) === getId(response, 0) &&
                  getId(search, 1) === getId(response, 1) &&
                  search.request[0].service === response.request[0].service
              );

              if (!(duplicateSearch.length >= 1)) {
                arr.unshift(response, ...recentSearches);
              } else {
                arr.unshift(...recentSearches);
              }
              if (arr.length > 4) {
                arr.splice(-1, 1);
              }
            } else {
              arr.unshift(response);
            }
            localStorage.setItem('recentSearches', JSON.stringify(arr));
            localStorage.setItem('timestamp', new Date().getTime());
          }
        }

        if (response && response.stops[0].chronological_departures.length) {
          dispatch({
            type: FETCH_SERVICES,
            payload: response,
          });
        }

        if (cb) {
          cb(response);
        }
      })
      .catch((error) => console.log(error));
  };
};



// WEBPACK FOOTER //
// ./src/actions/ServicesAction.js